function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1rem; /* space-y-4 */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem; /* space-y-2 */\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  flex: 1 1 0%; /* flex-1 */\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.5rem; /* ml-2 */\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem; /* gap-2 */\n  margin-top: 0.5rem; /* mt-2 */\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.5rem; /* px-2 py-1 */\n  background-color: var(--theme-primary-light, #dbeafe); /* bg-blue-100 dark:bg-blue-900/30 */\n  color: var(--theme-primary-dark, #1e40af); /* text-blue-800 dark:text-blue-300 */\n  border-radius: 0.375rem; /* rounded-md */\n  font-size: 0.75rem; /* text-xs */\n\n  .dark &, body.dark &, body.vscode-dark & {\n    background-color: var(--theme-primary-dark-accent, rgba(30, 64, 175, 0.3)); /* dark:bg-blue-900/30 */\n    color: var(--theme-primary-light-text, #bfdbfe); /* dark:text-blue-300 */\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.25rem; /* ml-1 */\n  color: var(--theme-primary, #2563eb); /* text-blue-600 dark:text-blue-400 */\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--theme-primary-dark, #1d4ed8); /* hover:text-blue-800 dark:hover:text-blue-200 */\n  }\n\n  .dark &, body.dark &, body.vscode-dark & {\n    color: var(--theme-primary-light-accent, #93c5fd); /* dark:text-blue-400 */\n    &:hover {\n        color: var(--theme-primary-lighter, #dbeafe); /* dark:hover:text-blue-200 */\n    }\n  }\n\n  svg {\n    height: 0.75rem; /* h-3 */\n    width: 0.75rem; /* w-3 */\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import { Input, Textarea, Button } from "@edusense/shared-ui-kit";
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import X from 'lucide-react/dist/esm/icons/x';
import styled from '@emotion/styled';
import { PROJECT_UPLOAD_TEST_IDS } from '@edusense/shared-constants';
var Label = function(param) {
    var htmlFor = param.htmlFor, children = param.children;
    return /*#__PURE__*/ React.createElement("label", {
        htmlFor: htmlFor,
        className: "block text-sm font-medium text-gray-700 dark:text-gray-300"
    }, children);
};
var Select = function(param) {
    var value = param.value, onValueChange = param.onValueChange, children = param.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("select", {
        value: value,
        onChange: function(e) {
            return onValueChange(e.target.value);
        },
        className: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-white"
    }, children));
};
var SelectTrigger = function(param) {
    var children = param.children;
    return children;
};
var SelectValue = function(param) {
    var placeholder = param.placeholder;
    return /*#__PURE__*/ React.createElement("option", {
        value: ""
    }, placeholder);
};
var SelectContent = function(param) {
    var children = param.children;
    return children;
};
var SelectItem = function(param) {
    var value = param.value, children = param.children;
    return /*#__PURE__*/ React.createElement("option", {
        value: value
    }, children);
};
// --- 스타일 컴포넌트 정의 ---
var FormContainer = styled.form(_templateObject());
var FormGroup = styled.div(_templateObject1());
var TagInputContainer = styled.div(_templateObject2());
var TagInput = styled(Input)(_templateObject3());
var AddTagButton = styled(Button)(_templateObject4());
var TagListContainer = styled.div(_templateObject5());
var TagItem = styled.div(_templateObject6());
var RemoveTagButton = styled.button(_templateObject7());
/**
 * 프로젝트 정보 입력 폼 컴포넌트
 * 
 * 🏗️ FSD Shared Layer - UI Project Forms
 * 프로젝트 메타데이터(제목, 설명, 태그) 입력을 위한 폼 컴포넌트
 */ var ProjectForm = function(param) {
    var values = param.values, onChange = param.onChange, isSubmitting = param.isSubmitting;
    var _React_useState = _sliced_to_array(React.useState(''), 2), tagInput = _React_useState[0], setTagInput = _React_useState[1];
    var handleTagAdd = function() {
        var tag = tagInput.trim();
        if (!tag) return;
        if (!values.tags.includes(tag)) {
            onChange('tags', _to_consumable_array(values.tags).concat([
                tag
            ]));
        }
        setTagInput('');
    };
    var handleTagRemove = function(tagToRemove) {
        onChange('tags', values.tags.filter(function(tag) {
            return tag !== tagToRemove;
        }));
    };
    var handleTagKeyPress = function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleTagAdd();
        }
    };
    return /*#__PURE__*/ React.createElement(FormContainer, null, /*#__PURE__*/ React.createElement(FormGroup, null, /*#__PURE__*/ React.createElement(Input, {
        id: "title",
        label: "프로젝트 제목",
        placeholder: "프로젝트 제목을 입력하세요",
        value: values.title,
        onChange: function(e) {
            return onChange('title', e.target.value);
        },
        required: true,
        "data-testid": PROJECT_UPLOAD_TEST_IDS.TITLE_INPUT
    })), /*#__PURE__*/ React.createElement(FormGroup, null, /*#__PURE__*/ React.createElement(Textarea, {
        id: "description",
        label: "프로젝트 설명",
        placeholder: "프로젝트에 대한 간단한 설명을 입력하세요",
        value: values.description,
        onChange: function(e) {
            return onChange('description', e.target.value);
        },
        required: true,
        rows: 3,
        "data-testid": PROJECT_UPLOAD_TEST_IDS.DESCRIPTION_INPUT
    })), /*#__PURE__*/ React.createElement(FormGroup, null, /*#__PURE__*/ React.createElement(TagInputContainer, null, /*#__PURE__*/ React.createElement(TagInput, {
        id: "tags",
        label: "태그",
        placeholder: "태그 입력 후 Enter 또는 추가 버튼 클릭",
        value: tagInput,
        onChange: function(e) {
            return setTagInput(e.target.value);
        },
        onKeyPress: handleTagKeyPress,
        "data-testid": PROJECT_UPLOAD_TEST_IDS.TAG_INPUT
    }), /*#__PURE__*/ React.createElement(AddTagButton, {
        type: "button",
        onClick: handleTagAdd,
        variant: "outline",
        "data-testid": PROJECT_UPLOAD_TEST_IDS.ADD_TAG_BUTTON
    }, "추가")), values.tags.length > 0 && /*#__PURE__*/ React.createElement(TagListContainer, null, values.tags.map(function(tag) {
        return /*#__PURE__*/ React.createElement(TagItem, {
            key: tag
        }, /*#__PURE__*/ React.createElement("span", null, tag), /*#__PURE__*/ React.createElement(RemoveTagButton, {
            type: "button",
            onClick: function() {
                return handleTagRemove(tag);
            },
            "aria-label": "Remove tag ".concat(tag)
        }, /*#__PURE__*/ React.createElement(X, null)));
    }))));
};
export default ProjectForm;
